module.exports = "h2 {\r\n  font-weight: 400;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home-social/home-social.component.css
// module id = ./src/app/home/home-social/home-social.component.css
// module chunks = main